import type { ReactNode } from "react";
import { Card } from "@/components/ui/card";

const LOGO_PATH = "/static/images/logo.png";

/**
 * Bare-bones branded shell for the provider-invite acceptance page. The page
 * renders for signed-out visitors, so it deliberately carries no app chrome
 * (nav, sidebar) beyond the logo — matching the other public pages
 * (`/`, `auth-provider/signin`).
 */
export function ProviderInviteShell({ children }: { children: ReactNode }) {
  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img
            src={LOGO_PATH}
            alt="Saile Company Logo"
            width={160}
            className="mx-auto"
          />
        </div>
        <Card>{children}</Card>
      </div>
    </main>
  );
}
